import { Navigate } from "react-router-dom"
import { Outlet } from "react-router"

export const ProtectedRoutes = () => {
  const token = localStorage.getItem("token")
  return token ? <Outlet /> : <Navigate to="/login" />
}
